import React, { FC } from "react";
import { Package } from "../../Center/CenterSettingsContainer/types";
import DataGrid from "../../Unknown/DataGrid";
import useGridColumns from "./useGridColumns";
import useStyles from "./useStyles";

export type CenterPackageViewProps = {
  packages: Package[];
  currencyCode: string;
  onArchiveClick: (packageId: string) => void;
  onEditClick: (packageId: string) => void;
};

const CenterPackageView: FC<CenterPackageViewProps> = ({
  packages,
  currencyCode,
  onArchiveClick,
  onEditClick,
}) => {
  const { root } = useStyles();
  const { columns } = useGridColumns({
    currencyCode,
    onArchiveClick,
    onEditClick,
  });

  return (
    <DataGrid
      autoHeight
      getRowHeight={() => "auto"}
      className={root}
      columns={columns}
      rows={packages}
      hideFooter
      hideFooterRowCount
      disableRowSelectionOnClick
      initialState={{
        sorting: { sortModel: [{ field: "name", sort: "asc" }] },
      }}
      sortingOrder={["desc", "asc"]}
    />
  );
};

export default CenterPackageView;
